import Vuex from 'vuex';
import Vue from 'vue';
import { DailyRepoStates } from './States/daily.report.states';
import { NavBarStates } from './States/nav.bar.states';
import { AppStates } from './States/app.states';
import { ScrollBarStates } from './States/scroll.bar';
import { PropertyDetailStates } from './States/property.detail.states';
import { HomeStates } from './States/home.states';
import { MutationsManager } from './mutations.manager';
import { AuthStates } from './States/auth.states';
import { SocialShareStates } from './States/social.share.states';
import { RifoTamplateStates } from './States/template.state';
import { MapEpicStates } from './States/map.epic.states';
import { EpicNavBarStates } from './States/epic.nav.bar';
import { NewsListStates } from './States/news.list.state';
import { CommonConfig } from '../../configs/config.common';
import { AxiosPromise } from '../../utils/axios.promise';
import { ESearchType } from '../../models/property.map.epic';
import { ActionsManager } from './actions.manager';


export namespace CommonStates {
  export function factory() {
    Vue.use(Vuex);
    const mutationsManager: MutationsManager.Manager = MutationsManager.factory();
    const actionsManager = ActionsManager.factory();
    const storeG = new Vuex.Store({
      state: {
        app: AppStates.appStatesFactory(),
        count: 0,
        auth: AuthStates.authStatesFactory(),
        home: HomeStates.homeStatesFactory(),
        navBar: NavBarStates.navBarStatesFactory(),
        printerOb: DailyRepoStates.dailyRepoPrintStatesFactory(),
        dailyReport: DailyRepoStates.dailyReportStates(),
        propertyDetail: PropertyDetailStates.propertyDetailStatesFactory(),
        scrollBar: ScrollBarStates.scrollBarStatesFactory(),
        socialShare: SocialShareStates.socialShareStatesFactory(),
        rifoTemplate: RifoTamplateStates.rifoTemplateStatesFactory(),
        mapEpic: MapEpicStates.factory(),
        epicNavBar: EpicNavBarStates.factory(),
        newsList: NewsListStates.newsListStatesFactory(),
      },
      mutations: mutationsManager.mutations,
      actions: actionsManager.actions,
    });
    return storeG;
  }
}
